// Generated by purs version 0.13.8
"use strict";
var $foreign = require("/home/runner/work/jackpooley.io/jackpooley.io/.spago/record/v2.0.2/src/Record/Unsafe/Union.js");
var Data_Function_Uncurried = require("/home/runner/work/jackpooley.io/jackpooley.io/.spago/functions/v4.0.0/src/Data/Function/Uncurried.purs");
var unsafeUnion = Data_Function_Uncurried.runFn2($foreign.unsafeUnionFn);
module.exports = {
    unsafeUnion: unsafeUnion,
    unsafeUnionFn: $foreign.unsafeUnionFn
};
